export const unitAmountToPriceText = (unitAmount = 0) => {
  return `$${(unitAmount / 100).toFixed(2)}`
}